import Icon from '../components/Icon.vue'

Icon.register({
  frog: {
    width: 576,
    height: 512,
    paths: [
      {
        d: 'M446.5 97.4c0 0 58.4 19.1 99 41.3 18.8 10.3 30.5 29.8 30.5 51.2v0c0 18.8-13.3 41.5-29.7 50.7l-154.4 86.7 98.5 104.7h53.6c17.7 0 32 14.3 32 32 0 8.8-7.2 16-16 16h-90.4l-118.5-125.9c5.1-54.1-29.9-85.1-40.8-93.2-36.8-27.6-88.3-27.7-125.1 0l-34.8 26.1c-7.1 5.3-8.5 15.3-3.2 22.4 5.3 7.1 15.3 8.5 22.4 3.2l32.8-24.6c20.7-15.5 48.3-20.8 72.2-10.9 44.1 18.3 57.9 70.4 33.7 106.6l-35.8 48.3h79.5c17.7 0 32 14.3 32 32 0 8.8-7.2 16-16 16h-304c-34.9 0-63.9-28.1-64-63-0.5-166.9 126.8-304 289.5-319.4 6.8-37.3 39.3-65.5 78.5-65.5 39.2 0 71.7 28.2 78.5 65.4zM368 136c13.3 0 24-10.8 24-24 0-13.3-10.8-24-24-24-13.3 0-24 10.7-24 24 0 13.3 10.7 24 24 24z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/frog.js
// module id = 1373
// module chunks = 0